module.exports = {
	"articleTitle1": "GEO votes for walkout, hosts sit-in at Union ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Michigan Union",
	"articleLink1": "https://www.michigandaily.com/section/administration/geo-votes-walkout-hosts-sit-union",
	"articleLink2": "https://www.michigandaily.com/section/administration/regents-discuss-union-renovations-and-divestment-controversial-meeting",
	"articleSnippet1": "Apr 10, 2017 ... Lining the halls of the University of Michigan Union, over 250 Graduate \nEmployees' Organization members and allies staged their third sit-in of ...",
	"articleSnippet2": "Mar 16, 2017 ... The University of Michigan's Dearborn campus hosted the year's ... Central to the \nmeeting were talks of renovations to the Michigan Union and ...",
	"totalMisc": 0,
	"articleTitle2": "Regents discuss Union renovations, divestment in March meeting ...",
	"address": "530 S State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170110/adr.NEW_.CSG_.1.10.17218.jpg?itok=EF5hdB5_",
			"author": "Alexis Rankin",
			"caption": "Students walk through the Union on Tuesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160410/eaa.NEW_.ArabXpressions.4.8.16.224_0.jpg?itok=5iPLh4k3",
			"author": "Evan Aaron",
			"caption": "Students perform Dabke, a traditional Arabic dance, at Arab Xpressions 2016, an event which celebrates Arabic culture that is hosted by the Arab Student Association in the Michigan Union Ballroom Friday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161104/eyx.FEA_.BloodDonation.11.3.16.13%20copy.jpg?itok=bMWirvfB",
			"author": "Elizabeth Xiong",
			"caption": "LSA senior Michelle Vosters donates blood to the American Red Cross in the Michigan Union on Thursday."
		}
	],
	"position": {
		"lat": 42.2752,
		"lng": -83.7415
	},
	"tips": [
		{
			"text": "Lots of good places to study and loads of food options here.",
			"person": "Erik Forkin"
		},
		{
			"text": "There's a game room with pool tables and xboxes on the 2nd floor",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/michiganunion.json
// module id = 922
// module chunks = 0